"use strict";

exports.DEFAULT_OPTIONS = {
  maxWidth: 650,
  wrapperStyle: "",
  backgroundColor: "white",
  linkImagesToOriginal: true,
  showCaptions: false,
  markdownCaptions: false,
  withWebp: false,
  tracedSVG: false,
  loading: "lazy",
  disableBgImageOnAlpha: false,
  disableBgImage: false
};
exports.imageClass = "gatsby-resp-image-image";
exports.imageWrapperClass = "gatsby-resp-image-wrapper";
exports.imageBackgroundClass = "gatsby-resp-image-background-image";


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-remark-images/constants.js
// module id = ./node_modules/gatsby-remark-images/constants.js
// module chunks = 231608221292675